import React from 'react';
import OfficeFilterDropdown from '@/components/util/OfficeFilterDropdown';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormOfficeSelector: React.FC = () => {
  const {
    resource,
    selectedOffice,
    offices,
    setSelectedOffice,
    currentOffice,
    setFilterFloor
  } = useReserveForm();

  return (
    <OfficeFilterDropdown
      className="grow"
      readonly={!!resource}
      setOfficeId={(id) => {
        const office = offices.find((x) => x.id === id) ?? currentOffice;
        setSelectedOffice(office);
        setFilterFloor(null);
      }}
      officeId={selectedOffice?.id ?? null}
      offices={offices}
    />
  );
};
